<script lang="ts" setup>
import { ref } from 'vue';
import { useClaimStore } from '@/store';
import Select from './Select.vue';

const compensationOptions: Array<{ value: number; label: string; }> = [
  { value: 0, label: "0 €" },
  { value: 125, label: "125 €" },
  { value: 250, label: "250 €" },
  { value: 200, label: "200 €" },
  { value: 400, label: "400 €" },
  { value: 300, label: "300 €" },
  { value: 600, label: "600 €" },
];

const selectedOptionIndex = ref(
  compensationOptions.findIndex((option) => option.value === useClaimStore().claim?.legalSpecification.ec261CompensationAmount)
);
</script>
<template>
  <div>
    <Select @update:modelValue="(value) => $emit('update:modelValue', value as any)"
      label="Montant règlement 261/2004"
      :options="compensationOptions"
      :selected-option="selectedOptionIndex"
    />
  </div>
</template>